import { useState } from 'react'
import ZodiacGlyph from '../horoscope/ZodiacGlyph'
import { ZODIAC_SIGNS } from '../horoscope/zodiacData'
import { ORBIT_ANGLES_12, CARDINAL_DOTS_8 } from './academyData'
import maharajJi2 from '../../../assets/images/maharaj-ji2.png'
function OuterZodiacOrbit() {
  return (
    <div
      className="zodiac-ring-a absolute pointer-events-none"
      style={{
        width: '460px',
        height: '460px',
        top: '50%',
        left: '50%',
        margin: '-230px',
        borderRadius: '50%',
        border: '1px solid rgba(245,158,11,.12)',
        boxShadow: '0 0 50px rgba(245,158,11,.05) inset',
      }}
    >
      {ORBIT_ANGLES_12.map((deg, i) => (
        <div
          key={deg}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '38px',
            height: '38px',
            margin: '-19px',
            transform: `rotate(${deg}deg) translateY(-230px)`,
          }}
        >
          <div
            style={{
              width: '38px',
              height: '38px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg,rgba(245,158,11,.26),rgba(245,158,11,.06))',
              border: '1px solid rgba(245,158,11,.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 0 18px rgba(245,158,11,.35),inset 0 1px 0 rgba(255,255,255,.18),0 0 0 3px rgba(245,158,11,.06)',
            }}
          >
            <ZodiacGlyph sign={ZODIAC_SIGNS[i].sign} className="w-4 h-4" style={{ color: 'rgba(245,158,11,.98)' }} />
          </div>
        </div>
      ))}
    </div>
  )
}

function MidCardinalOrbit() {
  return (
    <div
      className="zodiac-ring-b absolute pointer-events-none"
      style={{ width: '340px', height: '340px', top: '50%', left: '50%', margin: '-170px', borderRadius: '50%', border: '1px dashed rgba(245,158,11,.2)' }}
    >
      {CARDINAL_DOTS_8.map((deg, i) => {
        const big = i % 2 === 0
        const size = big ? 12 : 8
        return (
          <div
            key={deg}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: `${size}px`,
              height: `${size}px`,
              margin: `-${size / 2}px`,
              transform: `rotate(${deg}deg) translateY(-170px)`,
              background: big ? 'radial-gradient(circle,#FBBF24,rgba(245,158,11,.4))' : 'radial-gradient(circle,rgba(245,158,11,.7),transparent)',
              borderRadius: '50%',
              boxShadow: big ? '0 0 14px rgba(245,158,11,.85),0 0 28px rgba(245,158,11,.3)' : '0 0 8px rgba(245,158,11,.5)',
            }}
          />
        )
      })}
    </div>
  )
}

function InstructorPortrait() {
  const [imgFailed, setImgFailed] = useState(false)

  return (
    <div className="relative z-10 flex flex-col items-center justify-end" style={{ width: '370px', height: '490px' }}>
      <div
        style={{
          position: 'absolute',
          inset: '-3px',
          borderRadius: '30px',
          background: 'linear-gradient(160deg,rgba(245,158,11,.9) 0%,rgba(200,146,42,.35) 40%,rgba(245,158,11,.8) 80%,rgba(255,220,100,.6) 100%)',
          filter: 'blur(2px)',
          opacity: 0.7,
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '28px',
          padding: '2px',
          background: 'linear-gradient(160deg,rgba(255,220,80,.85) 0%,rgba(200,146,42,.3) 45%,rgba(245,158,11,.75) 100%)',
        }}
      >
        <div style={{ width: '100%', height: '100%', borderRadius: '26px', overflow: 'hidden', background: '#140602' }}>
          {!imgFailed ? (
            <img
              src={maharajJi2}
              alt="Astrologer Raju Maharaj Ji"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', transition: 'transform 8s ease-in-out' }}
              onMouseOver={(e) => { e.currentTarget.style.transform = 'scale(1.04)' }}
              onMouseOut={(e) => { e.currentTarget.style.transform = 'scale(1)' }}
              onError={() => setImgFailed(true)}
            />
          ) : (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'var(--font-heading),serif',
                fontSize: '100px',
                color: 'rgba(245,158,11,.22)',
              }}
            >
              ॐ
            </div>
          )}
        </div>
      </div>

      <div style={{ position: 'absolute', inset: 0, borderRadius: '28px', overflow: 'hidden', pointerEvents: 'none', zIndex: 2 }}>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '55%',
            height: '100%',
            background: 'linear-gradient(90deg,transparent,rgba(245,158,11,.09),rgba(255,230,120,.04),transparent)',
            transform: 'skewX(-12deg)',
            animation: 'la-beam-sweep 6s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '45%',
          borderRadius: '0 0 26px 26px',
          background: 'linear-gradient(to top,rgba(12,5,2,.96) 0%,rgba(12,5,2,.5) 55%,transparent 100%)',
          pointerEvents: 'none',
          zIndex: 3,
        }}
      />

      <div className="relative z-10 text-center" style={{ paddingBottom: '18px' }}>
        <p className="font-royal font-bold uppercase" style={{ fontSize: '12px', letterSpacing: '.26em', color: '#FBBF24', textShadow: '0 0 20px rgba(245,158,11,.6)' }}>
          Maharaj Ji
        </p>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginTop: '3px' }}>
          <div style={{ height: '1px', width: '16px', background: 'linear-gradient(90deg,transparent,rgba(245,158,11,.5))' }} />
          <p style={{ fontSize: '8px', letterSpacing: '.2em', color: 'rgba(255,255,255,.4)', textTransform: 'uppercase' }}>Chief Instructor</p>
          <div style={{ height: '1px', width: '16px', background: 'linear-gradient(90deg,rgba(245,158,11,.5),transparent)' }} />
        </div>
      </div>

      <div
        style={{
          position: 'absolute',
          inset: '-8px',
          borderRadius: '34px',
          boxShadow: '0 0 0 1px rgba(245,158,11,.15),0 24px 60px rgba(0,0,0,.75),0 0 40px rgba(245,158,11,.16),0 0 70px rgba(245,158,11,.06)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
    </div>
  )
}

const BADGES = [
  {
    key: 'experience',
    style: { top: '5%', left: '-4px', animationDelay: '0s' },
    icon: '🏆',
    value: '15+',
    label: 'Yrs Experience',
  },
  {
    key: 'rating',
    style: { top: '10%', right: '-4px', animationDelay: '-1.6s' },
    icon: '⭐',
    value: '4.9',
    valueSuffix: '/5',
    stars: true,
  },
]

function GoldBadge({ badge }) {
  return (
    <div
      className="la-float-badge absolute z-20"
      style={{
        ...badge.style,
        borderRadius: '18px',
        padding: '10px 14px',
        background: 'linear-gradient(135deg,rgba(18,8,2,.95),rgba(28,12,3,.92))',
        border: '1px solid rgba(245,158,11,.38)',
        boxShadow: '0 10px 32px rgba(0,0,0,.55),0 0 0 1px rgba(245,158,11,.08),inset 0 1px 0 rgba(245,158,11,.08)',
      }}
    >
      <div className="flex items-center gap-2.5">
        <div
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg,rgba(245,158,11,.32),rgba(245,158,11,.1))',
            border: '1px solid rgba(245,158,11,.32)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '17px',
            flexShrink: 0,
            boxShadow: '0 4px 12px rgba(245,158,11,.2),inset 0 1px 0 rgba(255,255,255,.1)',
          }}
        >
          {badge.icon}
        </div>
        <div>
          <p className="font-royal font-black leading-none" style={{ fontSize: '18px', color: '#FBBF24', textShadow: '0 0 16px rgba(245,158,11,.5)' }}>
            {badge.value}
            {badge.valueSuffix && <span style={{ fontSize: '10px', color: 'rgba(245,158,11,.55)', marginLeft: '2px' }}>{badge.valueSuffix}</span>}
          </p>
          {badge.stars ? (
            <p style={{ fontSize: '9px', color: '#FBBF24', letterSpacing: '.06em', marginTop: '2px' }}>★★★★★</p>
          ) : (
            <p style={{ fontSize: '7.5px', textTransform: 'uppercase', letterSpacing: '.16em', marginTop: '2px', color: 'rgba(255,255,255,.45)' }}>{badge.label}</p>
          )}
        </div>
      </div>
    </div>
  )
}

function LiveClassBadge() {
  return (
    <div
      className="la-float-badge absolute z-20"
      style={{
        bottom: '18%',
        right: '-4px',
        animationDelay: '-.8s',
        borderRadius: '18px',
        padding: '10px 14px',
        background: 'linear-gradient(135deg,rgba(8,22,12,.95),rgba(12,28,16,.92))',
        border: '1px solid rgba(34,197,94,.35)',
        boxShadow: '0 10px 32px rgba(0,0,0,.55),0 0 0 1px rgba(34,197,94,.07),0 0 16px rgba(34,197,94,.06),inset 0 1px 0 rgba(34,197,94,.08)',
      }}
    >
      <div className="flex items-center gap-2.5">
        <div
          style={{
            position: 'relative',
            width: '36px',
            height: '36px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg,rgba(34,197,94,.22),rgba(34,197,94,.07))',
            border: '1px solid rgba(34,197,94,.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            boxShadow: '0 4px 12px rgba(34,197,94,.15)',
          }}
        >
          <div className="live-ring" style={{ position: 'absolute', inset: 0, borderRadius: '12px', background: 'rgba(34,197,94,.1)' }} />
          <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 12px rgba(34,197,94,.95),0 0 22px rgba(34,197,94,.4)', zIndex: 1 }} />
        </div>
        <div>
          <p style={{ fontSize: '7.5px', fontWeight: 900, textTransform: 'uppercase', letterSpacing: '.2em', color: '#4ade80' }}>Live Now</p>
          <p style={{ fontSize: '11px', fontWeight: 600, color: '#fff', marginTop: '2px', letterSpacing: '.01em' }}>Kundli Masterclass</p>
          <p style={{ fontSize: '7.5px', color: 'rgba(255,255,255,.4)', marginTop: '1px' }}>42 students online</p>
        </div>
      </div>
    </div>
  )
}

function StudentsBadge() {
  return (
    <div
      className="la-float-badge absolute z-20"
      style={{
        bottom: '10%',
        left: '-4px',
        animationDelay: '-2.4s',
        borderRadius: '18px',
        padding: '10px 14px',
        background: 'linear-gradient(135deg,rgba(18,8,2,.95),rgba(28,12,3,.92))',
        border: '1px solid rgba(245,158,11,.38)',
        boxShadow: '0 10px 32px rgba(0,0,0,.55),0 0 0 1px rgba(245,158,11,.08),inset 0 1px 0 rgba(245,158,11,.08)',
      }}
    >
      <div className="flex items-center gap-2.5">
        <div className="flex -space-x-1.5 shrink-0">
          {[
            { letter: 'R', gradient: 'linear-gradient(135deg,#D97706,#92400E)' },
            { letter: 'S', gradient: 'linear-gradient(135deg,#B45309,#7C2D12)' },
            { letter: 'A', gradient: 'linear-gradient(135deg,#92400E,#451A03)' },
          ].map((a) => (
            <div
              key={a.letter}
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                border: '2px solid rgba(245,158,11,.5)',
                background: a.gradient,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '9px',
                fontWeight: 700,
                color: '#FDE68A',
                boxShadow: '0 0 8px rgba(245,158,11,.2)',
              }}
            >
              {a.letter}
            </div>
          ))}
        </div>
        <div>
          <p className="font-royal font-black leading-none" style={{ fontSize: '18px', color: '#FBBF24', textShadow: '0 0 16px rgba(245,158,11,.5)' }}>
            500+
          </p>
          <p style={{ fontSize: '7.5px', textTransform: 'uppercase', letterSpacing: '.16em', marginTop: '2px', color: 'rgba(255,255,255,.45)' }}>Students Guided</p>
        </div>
      </div>
    </div>
  )
}

export default function AcademyZodiacWheel() {
  return (
    <div
      className="order-1 lg:order-2 flex items-center justify-center relative"
      style={{ minHeight: '560px', width: '100%', maxWidth: '560px', margin: '0 auto' }}
    >
      <div
        className="absolute pointer-events-none"
        style={{
          width: '500px',
          height: '500px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          background: 'radial-gradient(circle at 50% 52%,rgba(245,158,11,.26) 0%,rgba(161,60,10,.18) 35%,transparent 62%)',
          filter: 'blur(60px)',
        }}
      />
      <div
        className="absolute pointer-events-none"
        style={{
          width: '280px',
          height: '280px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          background: 'radial-gradient(circle,rgba(245,158,11,.38) 0%,transparent 58%)',
          filter: 'blur(36px)',
        }}
      />
      <div
        className="absolute pointer-events-none"
        style={{
          width: '140px',
          height: '140px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          background: 'radial-gradient(circle,rgba(255,200,80,.55) 0%,transparent 55%)',
          filter: 'blur(20px)',
        }}
      />

      <div
        className="absolute pointer-events-none"
        style={{ width: '500px', height: '500px', top: '50%', left: '50%', margin: '-250px', borderRadius: '50%', border: '1px solid rgba(245,158,11,.06)', boxShadow: '0 0 60px rgba(245,158,11,.03) inset' }}
      />

      <OuterZodiacOrbit />
      <MidCardinalOrbit />

      <div className="absolute pointer-events-none" style={{ inset: '30%', animation: 'custom-spin 64s linear infinite' }}>
        <svg viewBox="0 0 200 200" className="w-full h-full" fill="none">
          <circle cx="100" cy="100" r="96" stroke="#E6C878" strokeOpacity="0.26" strokeDasharray="2 9" />
        </svg>
      </div>

      <InstructorPortrait />

      {BADGES.map((badge) => (
        <GoldBadge badge={badge} key={badge.key} />
      ))}
      <LiveClassBadge />
      <StudentsBadge />
    </div>
  )
}
